import { Serializer } from "../resource/serializer.interface";
import { ContactPreferenceHistory } from "./contact-preference-history.model";

export class ContactPreferenceHistorySerializer implements Serializer {
    fromJson(json: any): ContactPreferenceHistory {
        const contactPreferenceHistory = new ContactPreferenceHistory();
        contactPreferenceHistory.id = json.id;
        contactPreferenceHistory.emailAddress = json.email_address;
        contactPreferenceHistory.masterPreferenceId = json.masterPreference_Id;
        contactPreferenceHistory.value = json.value;
        contactPreferenceHistory.formId = json.form_Id;
        contactPreferenceHistory.pageId = json.page_Id;
        contactPreferenceHistory.channels = json.channels;
        contactPreferenceHistory.frequencies = json.frequencies;
        contactPreferenceHistory.tenantId = json.tenant_id;
        contactPreferenceHistory.dateCreated = json.created_at;
        contactPreferenceHistory.source = json.source;
        return contactPreferenceHistory;
    }

    toJson(contactPreferenceHistory: ContactPreferenceHistory): any {
        return {
            id: contactPreferenceHistory.id,
            email_address: contactPreferenceHistory.emailAddress,
            masterPreference_Id: contactPreferenceHistory.masterPreferenceId,
            value: contactPreferenceHistory.value,
            form_Id: contactPreferenceHistory.formId,
            page_Id: contactPreferenceHistory.pageId,
            channels: contactPreferenceHistory.channels,
            frequencies: contactPreferenceHistory.frequencies,
            tenant_id: contactPreferenceHistory.tenantId,
            created_at: contactPreferenceHistory.dateCreated,
            source: contactPreferenceHistory.source
        };
    }
}
